import React from 'react';
import classNames from 'classnames';
import { array, bool, number, oneOfType, object } from 'prop-types';
import { Carousel, Slider } from '@fiverr-private/orca';
import { BREAKPOINTS } from '@fiverr-private/orca/dist/src/components/Carousel/constants';
import { createGigsSkeleton } from '../../GigCardListings/utils';
import { SLIDER_BASE_NUM } from '../../GigCardListings/ListingCarousel/constants';
import LoadingBasicGigCard from '../../GigCards/ModernGigCards/loading/LoadingBasicGigCard';
import { createSliderSettings } from '../../GigCardListings/ListingCarousel/helper';

import '../../GigCardListings/ListingCarousel/index.scss';

export const LoadingGigCardWrapper = () => (
    <div className="gig-wrapper-impressions">
        <LoadingBasicGigCard />
    </div>
);

export const DEFAULT_SLIDER_BREAKPOINTS = {
    [BREAKPOINTS.BP_600]: 1,
    [BREAKPOINTS.BP_750]: 2,
    [BREAKPOINTS.BP_900]: 3,
    [BREAKPOINTS.BP_1300]: 4,
};

const LoadingGigCardCarousel = (props) => {
    const { isTouch = false } = props;
    const carouselClassName = classNames('listing-carousel', 'loading-gig-card-carousel', { 'touch-slider': isTouch });

    // This is used in order to allow backward compatibility support
    // until all consumers will use the new Penta's Carousel API
    // (breakpoints structure and values are different and cannot be simply mapped).
    const CarouselComponent = getCarouselComponent(props);

    return <div className={carouselClassName}>{CarouselComponent}</div>;
};

const getCarouselComponent = ({
    sliderBreakpoints,
    slidesToShow = SLIDER_BASE_NUM,
    isTouch = false,
    isInfinite = false,
}) => {
    const isConsumerUsesOldAPI = sliderBreakpoints && sliderBreakpoints[0]?.breakpoint;
    const items = createGigsSkeleton(slidesToShow);

    if (isConsumerUsesOldAPI) {
        const sliderSettings = createSliderSettings({
            slidesToShow,
            breakpoints: sliderBreakpoints,
            isTouch,
            isInfinite,
        });

        return (
            <Slider
                items={items}
                freeScroll={isTouch}
                isTouch={isTouch}
                Component={LoadingGigCardWrapper}
                {...sliderSettings}
            />
        );
    }

    return (
        <Carousel
            slides={items}
            hideDefaultArrows
            slidesToShow={slidesToShow}
            Component={LoadingGigCardWrapper}
            breakpoints={sliderBreakpoints || DEFAULT_SLIDER_BREAKPOINTS}
            isInfinite={isInfinite}
        />
    );
};

LoadingGigCardCarousel.propTypes = {
    isTouch: bool,
    // eslint-disable-next-line react/no-unused-prop-types
    sliderBreakpoints: oneOfType([array, object]),
    // eslint-disable-next-line react/no-unused-prop-types
    slidesToShow: number,
    // eslint-disable-next-line react/no-unused-prop-types
    isInfinite: bool,
};

export default LoadingGigCardCarousel;
